<template>
  <v-container fluid class="service-detail-height pa-0 pt-2">
    <v-row>
      <!-- Basic Information Card -->
      <v-col cols="12">
        <v-card outlined elevation="0" class="mb-4 h-100">
          <div
            class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom"
          >
            <div class="d-flex align-center">
              <v-icon class="mr-2" color="blue darken-2" small
                >mdi-information-outline</v-icon
              >
              <h3
                class="font-size-18 font-weight-700 mb-0 color-custom-blue text-uppercase"
              >
                Basic Information
              </h3>
            </div>
          </div>
          <v-card-text class="px-4 py-1 font-size-16 pre-wrap">
            <table class="width-100">
              <tr>
                <td
                  style="width: 170px"
                  valign="top"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Specification
                </td>
                <td
                  valign="middle"
                  class="py-1 font-size-18 border-bottom-dashed"
                >
                  <span v-if="detail && detail.specification">
                    {{ detail.specification }}
                  </span>
                  <em v-else class="text-muted"> no specification </em>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 170px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Tags
                </td>
                <td
                  valign="middle"
                  class="py-1 font-size-18 border-bottom-dashed"
                >
                  <template v-if="detail?.tags && detail.tags.length > 0">
                    <span v-if="detail && detail.tags">
                      <v-chip
                        v-for="(row, index) in detail.tags"
                        :key="index"
                        class="mr-2 font-weight-600"
                        text-color="white"
                        :color="row.color"
                        small
                        label
                        >{{ row.text }}</v-chip
                      >
                    </span>
                  </template>
                  <em v-else class="text-muted"> no Tags</em>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 170px"
                  valign="top"
                  class="py-1 font-size-18 font-weight-500"
                >
                  Description
                </td>
                <td valign="middle" class="py-1 font-size-18">
                  <span v-if="detail && detail.description">{{
                    detail.description
                  }}</span>
                  <em v-else class="text-muted"> no description </em>
                </td>
              </tr>
            </table>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Skills, Licence & Certs Information Card -->
      <v-col cols="12" class="pb-0 pt-0" v-if="show_skills == 1">
        <v-card outlined elevation="0" class="mb-4">
          <div
            class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom"
          >
            <div class="d-flex align-center">
              <v-icon class="mr-2" color="cyan darken-2" small
                >mdi-certificate-outline</v-icon
              >
              <h3
                class="font-size-18 font-weight-700 mb-0 color-custom-blue text-uppercase"
              >
                Skills , Licence & Certs Information
              </h3>
            </div>
          </div>
          <v-card-text class="pa-4 font-size-16">
            <v-simple-table fixed-header max-height="67vh">
              <template v-slot:default>
                <thead>
                  <tr class="grey lighten-4">
                    <th class="simple-table-th px-4" style="width: 50px">#</th>
                    <th class="simple-table-th px-4" style="width: 100px">
                      Color
                    </th>
                    <th class="simple-table-th px-4">Name</th>
                    <th class="simple-table-th px-4">Type</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="detail?.certificates?.length > 0">
                    <tr
                      v-for="(row, index) in detail.certificates"
                      :key="index"
                      :class="{
                        'custom-border-top': index == 0,
                        'orange_lighten-5': index % 2 == 0,
                      }"
                    >
                      <td class="simple-table-td px-4">{{ index + 1 }}</td>
                      <td class="simple-table-td px-4">
                        <v-chip
                          small
                          :color="row.color"
                          label
                          style="height: 18px; min-width: 26px"
                        ></v-chip>
                      </td>
                      <td
                        class="simple-table-td px-4 text-capitalize font-weight-600"
                      >
                        {{ row.name }}
                      </td>
                      <td class="simple-table-td px-4 text-capitalize">
                        {{ row.type }}
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <template v-if="pageLoading">
                      <tr v-for="row in 5" :key="row">
                        <td>
                          <v-skeleton-loader
                            type="text"
                            class="custom-skeleton table-rows-text"
                          ></v-skeleton-loader>
                        </td>
                        <td>
                          <v-skeleton-loader
                            type="text"
                            class="custom-skeleton table-rows-text"
                          ></v-skeleton-loader>
                        </td>
                        <td>
                          <v-skeleton-loader
                            type="text"
                            class="custom-skeleton table-rows-text"
                          ></v-skeleton-loader>
                        </td>
                        <td>
                          <v-skeleton-loader
                            type="text"
                            class="custom-skeleton table-rows-text"
                          ></v-skeleton-loader>
                        </td>
                      </tr>
                    </template>
                    <tr v-else-if="!pageLoading">
                      <td colspan="4">
                        <p
                          class="m-0 row-not-found text-center font-weight-500 font-size-16 py-4"
                        >
                          <img
                            :src="$assetURL('media/error/empty.png')"
                            class="row-not-found-image mb-2"
                          />
                          <br />Uhh... There are no row at the moment.
                        </p>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
      <CustomFormDetail
        class="px-0 col-12"
        module="service"
        :module-id="detail.id"
      />
    </v-row>
  </v-container>
</template>

<script>
import CustomFormDetail from "@/view/pages/custom-field-v2/CustomFormDetail.vue";
import moment from "moment-timezone";
import { GET } from "@/core/services/store/request.module";
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  data() {
    return {
      product: 0,
      panel: 0,
      panelImage: 0,
      pageLoading: false,
      dataLoading: true,
      summary: "this_week",
      show_skills: 0,
      summaryFilter: [
        { text: "This Week", value: "this_week" },
        { text: "Previous Week", value: "previous_week" },
        { text: "This Month", value: "this_month" },
        { text: "Previous Month", value: "previous_month" },
        /*{ text: "This Quarter", value: "this_quarter" },
        { text: "Previous Quarter", value: "previous_quarter" },*/
        { text: "This Year", value: "this_year" },
        { text: "Previous Year", value: "previous_year" },
      ],
      certificates: [],
    };
  },
  props: {
    detail: {
      type: Object,
      required: true,
      default: () => {
        return new Object();
      },
    },
  },
  watch: {
    detail: {
      deep: true,
      immediate: true,
      handler(param) {
        this.product = this.lodash.toSafeInteger(param.id);
      },
    },
  },
  components: {
    CustomFormDetail,
  },
  methods: {
    getServiceSetting() {
      const _this = this;
      _this.$store
        .dispatch(GET, { url: "setting/service" })
        .then(({ data }) => {
          _this.show_skills = data.service_skills_allow;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },
  mounted() {
    /* this.getSummary(); */
    this.getServiceSetting();
  },
};
</script>
<style scoped>
.v-expansion-panel::before {
  box-shadow: none;
}
</style>
